import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search1'
})
export class Search1Pipe implements PipeTransform {

 public transform(value, keys: string, term: string) {
  if (!term) return value;
  var lst = (value || []).filter((single) => keys.split(',').some(key => single.hasOwnProperty(key) && new RegExp(term, 'gi').test(single[key])));
     sessionStorage.setItem('len1',lst.length)   
   return lst 
  }

}
